import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LoginPageSlidesSmall from "./LoginPageSlidesSmall";
import LoginPageLatestNewsSmall from "./LoginPageLatestNewsSmall";
import LoginPageLinksSmall from "./LoginPageLinksSmall";
import ContactUsSmall from "../home/ContactUsSmall";
import ContactTenantsSmall from "../home/ContactTenantsSmall";
import { paperPlaneIcon } from '../../img/font_awesome/font_awesome';
import packageJson from '../../../package.json';

export default function LoginSmall() {
	const history = useHistory();
	const serverProductVersions = useSelector((state) => state.serverProductVersionsReducer.combinedVersion);
	const countyName = useSelector((state) => state.countyConfigCommonReducer.countyName);
	const appTitle = useSelector((state) => state.countyConfigCommonReducer.appTitle);
	const multiTenantSettings = useSelector((state) => state.countyConfigMultiTenantSettingsReducer);
	const [openLatestNews, setOpenLatestNews] = React.useState(true);
	const [openLinks, setOpenLinks] = React.useState(true);
	const [openContactUs, setOpenContactUs] = React.useState(true);
	const isNarrowScreen = window.innerWidth <= 360;

	let copyrightYear = new Date().getFullYear();
	if (copyrightYear > 2022) {
		copyrightYear = '2022-' + copyrightYear;
	}

	const handleLoginClick = () => {
		history.push("/loginMobile");
	};

	const handleRegisterClick = () => {
		history.push("/registerMobile");
	};

	const handleLoginHelpClick = () => {
		history.push("/loginHelpMobile");
	};

	return (
		<div>
			<div style={styles.banner}>
				<div style={styles.logoContainer}>
					{paperPlaneIcon}
				</div>
				{/* Center: Title */}
				<div style={styles.titleContainer}>
					<div
						style={{
							...styles.title,
							fontSize: isNarrowScreen ? "16px" : "20px",
						}}
					>
						{countyName}</div>
					<div
						style={{
							...styles.subtitle,
							fontSize: isNarrowScreen ? "13px" : "16px",
						}}
					>
						{appTitle}</div>
				</div>

				{/* Right: Log In */}
				<div style={styles.right}>
					<button style={styles.loginButton} onClick={handleLoginClick}>
						Log In
					</button>
				</div>
			</div>

			<div style={styles.content}>
				<div style={styles.registerContainer}>
					<button
						style={styles.forgotButton}
						onClick={handleLoginHelpClick}
					>
						Login Help
					</button>
					<button
						style={styles.registerButton}
						onClick={handleRegisterClick}
					>
						New User Registration
					</button>
				</div>


				<LoginPageLatestNewsSmall
					isOpen={openLatestNews === true}
					onToggle={() =>
						setOpenLatestNews(
							!openLatestNews
						)
					}
				/>

				<div style={{ height: "2px" }} />

				<LoginPageSlidesSmall />

				{/* <div style={{ height: "8px" }} /> */}
				<div
					style={{
						...styles.accordionContainer,
						boxShadow: openLinks
							? "0 4px 10px rgba(0,0,0,0.08)"
							: "0 1px 3px rgba(0,0,0,0.05)",
					}}
				>
					<div
						style={{
							...styles.accordionHeader,
							backgroundColor: openLinks ? "#5A6268" : "#6C757D",
						}}
						onClick={() => setOpenLinks(!openLinks)}
					>
						<span>Useful Links</span>

						<span
							style={{
								...styles.accordionIcon,
								transform: openLinks ? "rotate(180deg)" : "rotate(0deg)",
								transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
								display: "inline-block",
							}}
						>
							▼
						</span>
					</div>

					<div
						style={{
							...styles.accordionWrapper,
							maxHeight: openLinks ? "2000px" : "0px",
						}}
					>
						<div
							style={{
								...styles.accordionContent,
								opacity: openLinks ? 1 : 0,
								transition: "opacity 0.2s ease 0.08s",
							}}
						>
							<LoginPageLinksSmall bare />
						</div>
					</div>
				</div>

				{
					multiTenantSettings.multiTenant === true ? (
						<ContactTenantsSmall
							isOpen={openContactUs === true}
							onToggle={() => setOpenContactUs(!openContactUs)}
							endpoint="auth/loginPageContactUs"
							redirectOnAuthError={false}
						/>
					) : (
						<ContactUsSmall
							isOpen={openContactUs === true}
							onToggle={() => setOpenContactUs(!openContactUs)}
							endpoint="auth/loginPageContactUs"
							redirectOnAuthError={false}
						/>
					)
				}
			</div>

			<div style={styles.footer}>
				<div>
					Powered by <strong>TriMin Systems Land Notification v{packageJson.version}u{serverProductVersions}</strong>
				</div>

				<div style={styles.footerDescription}>
					Land Notification is designed, engineered, and supported in
					St. Paul, MN, and is part of our land records management
					software suite.
				</div>

				<div style={styles.copyright}>
					© {copyrightYear} TriMin Systems
				</div>
			</div>
		</div>
	);
}

// Styles
const styles = {

	banner: {
		display: "grid",
		gridTemplateColumns: "auto 1fr auto",
		alignItems: "center",
		backgroundColor: "#114E6B",
		color: "white",
		padding: "14px 16px",
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		boxSizing: "border-box",
		overflowX: "hidden",
		zIndex: 1000,
	},

	left: {
		justifySelf: "start",
	},
	right: {
		justifySelf: "end",
	},

	titleContainer: {
		marginLeft: "8px",
		textAlign: "left",
	},

	title: {
		fontWeight: "700",
		fontSize: "20px",
		lineHeight: "1.2",
		color: "white",
	},

	subtitle: {
		fontSize: "16px",
		letterSpacing: "0.5px",
		opacity: 0.9,
		color: "white",
	},

	loginButton: {
		backgroundColor: "white",
		color: "#114E6B",
		border: "none",
		padding: "10px 16px",
		borderRadius: "6px",
		cursor: "pointer",
		fontWeight: "700",
		fontSize: "14px",
	},

	content: {
		marginTop: "40px",
		padding: "16px",
	},

	registerContainer: {
		marginTop: "30px",
		display: "flex",
		justifyContent: "flex-end",
		gap: "16px",
	},

	forgotButton: {
		background: "none",
		border: "none",
		padding: 0,
		color: "#114E6B",
		textDecoration: "underline",
		cursor: "pointer",
		fontWeight: "bold",
		fontSize: "14px",
	},

	registerButton: {
		background: "none",
		border: "none",
		padding: 0,
		color: "#114E6B",
		textDecoration: "underline",
		cursor: "pointer",
		fontWeight: "bold",
		fontSize: "14px",
	},

	accordionContainer: {
		marginTop: "16px",
		border: "2px solid #6C757D",
		borderRadius: "6px",
		overflow: "hidden",
		transition: "box-shadow 0.3s ease",
		boxShadow: "0 4px 12px rgba(108, 117, 125, 0.12)",
	},

	accordionHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "10px 12px",
		cursor: "pointer",
		backgroundColor: "#6C757D",
		fontWeight: "bold",
		color: "white",
		transition: "background-color 0.2s ease",
	},

	accordionIcon: {
		fontSize: "12px",
	},

	accordionWrapper: {
		overflow: "hidden",
		transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
	},

	accordionContent: {
		backgroundColor: "white",
	},

	footer: {
		marginTop: "24px",
		padding: "16px",
		borderTop: "1px solid #D8E4EA",
		backgroundColor: "#FAFCFD",
		textAlign: "left",
		fontSize: "12px",
		color: "#114E6B",
		lineHeight: "1.5",
	},

	copyright: {
		opacity: 0.8,
	},

	logoContainer: {
		width: "40px",
		height: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "20px",
		fontWeight: "bold",
		color: "white",
	},
};
